import { render, staticRenderFns } from "./RoadTrips.vue?vue&type=template&id=34f21437&scoped=true&lang=pug&"
import script from "./RoadTrips.vue?vue&type=script&lang=js&"
export * from "./RoadTrips.vue?vue&type=script&lang=js&"
import style0 from "./RoadTrips.vue?vue&type=style&index=0&id=34f21437&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f21437",
  null
  
)

export default component.exports